/* eslint-disable no-param-reassign */
export default (state, { payload }) => {
  const { id, title } = payload;
  const instanceIndex = state.trayInstances.findIndex((instance) => instance.id === id);
  if (instanceIndex >= 0) {
    state.trayInstances[instanceIndex].title = title;
  }
};
